import ContractForm from './ContractForm.vue';

export default ContractForm;
